import type { Routes } from '@angular/router'
import type { ProductConfiguration } from '@awork/_shared/services/product/product-configuration'
import { createAworkRoutes } from './awork.routes'

/**
 * Creates the aworkAI proof-of-concept composition.
 * @param {ProductConfiguration} productConfiguration Selected product configuration.
 * @returns {Routes} aworkAI routes.
 */
export function createaworkAIRoutes(productConfiguration: ProductConfiguration): Routes {
  return createAworkRoutes(productConfiguration)
}
